/* eslint-disable camelcase */
import moment from "moment";
import { MatchScore, SearchMatchScoreResponse } from "../types";
import { ConvertUTCDatesBasedOnTimeZone } from "./timeZone";

export function GroupSlotsBasedOnDate(
    matchScoreResponse: SearchMatchScoreResponse,
    practiceTimeZone: string,
    isCAAvailibility: boolean,
): Array<any> {
    const { date_requested_utc, match_scores } = matchScoreResponse;
    let groupedMatchedScore: MatchScore[] = [];

    const datesRequested = date_requested_utc;

    const formatedDateRequested = ConvertUTCDatesBasedOnTimeZone(datesRequested, isCAAvailibility && practiceTimeZone ? practiceTimeZone : undefined);

    if (match_scores?.length) {
        const _slots = [...match_scores];

        _slots.forEach((slot: any) => {
            slot.grouped_slot_data =
                generateEmptyScheduleForRequestedDates(formatedDateRequested);

            if (slot?.slots_data?.length) {
                // eslint-disable-next-line space-before-function-paren
                const groupedData = slot.slots_data.reduce(function (
                    r: any,
                    a: any
                ) {
                    const date =
                        practiceTimeZone && isCAAvailibility
                            ? moment(a?.slot_start_date_time)
                                  .tz(practiceTimeZone)
                                  .format("YYYY-MM-DD")
                            : moment(a?.slot_start_date_time).format(
                                  "YYYY-MM-DD"
                              );

                    r[date] = r[date] || [];
                    r[date].push(a);

                    return r;
                },
                Object.create(null));

                slot.grouped_slot_data = Object.assign(
                    slot.grouped_slot_data,
                    groupedData
                );
            }
        });

        groupedMatchedScore = [..._slots];
    }

    return groupedMatchedScore;
}

function generateEmptyScheduleForRequestedDates(
    requestedDates: string[]
): Array<any> {
    const schedule: any = {};

    requestedDates.forEach((date: string) => {
        schedule[date] = [];
    });

    return schedule;
}
